import { useRef } from "react";

import { useProductPageHeaderHeight } from "../hooks/useProductPageHeaderHeight";
import { ProductFullV2Wrapper } from "./V2/ProductFullV2Wrapper";
import { ProductGalleryV2Skeleton } from "./V2/ProductGalleryV2Skeleton";
import { ProductHeaderV2Skeleton } from "./V2/ProductHeaderV2Skeleton";
import { ProductInformationSkeleton } from "./V2/ProductInformationSkeleton";
import { ProductNavigationSkeleton } from "./V2/ProductNavigationSkeleton";

type ProductFullV2SkeletonProps = {
    constrainWidth?: boolean;
    withStickyAppBar: boolean;
    showNavigator?: boolean;
};

export function ProductFullV2Skeleton(props: ProductFullV2SkeletonProps) {
    const { constrainWidth, showNavigator = true } = props;
    const headerRef = useRef<HTMLDivElement | null>(null);
    const { headerHeight } = useProductPageHeaderHeight(headerRef);

    return (
        <>
            <ProductHeaderV2Skeleton
                productRatingComponent={null}
                showHeader={true}
                withStickyAppBar={false}
                ref={headerRef}
            />
            <ProductFullV2Wrapper constrainWidth={constrainWidth} showNavigator={showNavigator}>
                <ProductGalleryV2Skeleton />
                {showNavigator && <ProductNavigationSkeleton headerHeight={headerHeight} />}
                <ProductInformationSkeleton />
            </ProductFullV2Wrapper>
        </>
    );
}
